import React from 'react';
import { Brand, getBrandFromUrl } from '../../core/context/claims';
import vippsProdQR from './VippsKlarnaPROD.svg';
import mobilePayProdQR from './MPKlarnaPROD.svg';
import vippsUATQR from './VippsKlarnaUAT.svg';
import mobilePayUATQR from './MPKlarnaUAT.svg';
import enrollKlarnaCard from './KlarnaSuccess.svg';
import './EnrollKlarnaQR.css';
import { useDevice } from '../../platform/device/useDevice';
import { env } from '../../core/util/env';

const getCorrectImage = (isOnMobile: boolean, brand: Brand) => {
  if (isOnMobile) {
    return enrollKlarnaCard;
  }
  if (brand === Brand.VIPPS) {
    return env.PROD ? vippsProdQR : vippsUATQR;
  } else {
    return env.PROD ? mobilePayProdQR : mobilePayUATQR;
  }
};

function EnrollKlarnaImage(): React.ReactNode {
  const isOnMobile = useDevice().isMobile;
  const brand = getBrandFromUrl();
  const qr = getCorrectImage(isOnMobile, brand);

  return (
    <div className="enroll-klarna-qr">
      <img
        src={qr}
        alt="Klarna enrollment QR code"
        className="enroll-klarna-qr-image"
        style={{ width: '100%' }}
      />
    </div>
  );
}

export default EnrollKlarnaImage;
